import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	fetchProcesses: ({ plantCd, urlSearchParams }) => {
		return client
			.get(`${BASE_URL}/daemon/v1/plants/${plantCd}/processes?${urlSearchParams}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchPgmIds: ({ plantCd }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/programs`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	fetchProcIdsByPgmId: ({ plantCd, pgmId }) => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${plantCd}/processes?pgmId=${pgmId}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	setStatus: ({ plantCd, runStatus, pgmUrl, daemon }) => {
		return client
			.post(`${BASE_URL}/daemon/v1/status/2/plants/${plantCd}/processes/runStatus/${runStatus}?pgmUrl=${pgmUrl}`, daemon)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	getControl: ({ plantCd, scrId, userId }) => {
		return client
			.post(`${BASE_URL}/userLock/v1/status/1/plants/${plantCd}/screens/${scrId}/userControl`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	returnControl: ({ plantCd, scrId, userId }) => {
		return client
			.post(`${BASE_URL}/userLock/v1/status/2/plants/${plantCd}/screens/${scrId}/userControl`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}
};
